<template>
    <div>
        <SearchObject
            :additional-params="{ ordering: 'name', ...additionalParams }"
            :allow-create="allowCreate"
            :autofocus="autofocus"
            :base-url="baseUrl"
            :create-label="$translate('create_logistics_operator')"
            :disabled="disabled"
            :hide-details="hideDetails"
            :item-text="itemText"
            :label="label || $translate('select_logistics_operator')"
            :readonly="readonly"
            :required="required"
            :value="value"
            :icon="icon"
            :flat="flat"
            :outlined="outlined"
            :background-color="backgroundColor"
            @create="createOperator"
            @input="onSearchInput"
            @select="$emit('select', $event)"
            :error-messages="errorMessages"
            ref="search"
            :dense="dense"
        >
            <template slot="item" slot-scope="{ item }">
                <span>{{ itemText(item) }}</span>
                <span
                    v-if="item.entity"
                    class="text-caption text--secondary ml-2"
                >
                    ({{ $translate("connected") }})
                </span>
            </template>
        </SearchObject>
    </div>
</template>

<script>
import EditOperatorLogistics from "@/modals/operator-logistics";
import GlobalMixins from "@/mixins/global";
import SearchObject from "@/components/common/search-object.vue";

export default {
    mixins: [GlobalMixins],
    name: "SearchOperator",
    components: { SearchObject },
    props: {
        baseUrl: {
            type: String,
            default: "/api/operators/",
        },
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        label: {
            type: String,
            required: false,
        },
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        backgroundColor: {
            type: String,
            default: null,
        },
        /** Passed to EditOperatorLogistics when using create flow (e.g. warehouse prefills). */
        createModalParams: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        async createOperator() {
            const result = await this.showModal({
                component: EditOperatorLogistics,
                params: { ...this.createModalParams },
            });
            if (result) {
                this.onSearchInput(result.id);
                this.$refs.search.update();
            } else {
                this.$refs.search.reset();
            }
        },
        onSearchInput(val) {
            if (val == null || val === "") {
                this.$emit("input", null);
                return;
            }
            const id = typeof val === "object" && val !== null ? val.id : val;
            this.$emit("input", id);
        },
        itemText(item) {
            return item?.name || "";
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_logistics_operator: "Logistics provider (optional)",
                create_logistics_operator: "Create logistics provider",
                connected: "connected",
            },
            fr: {
                select_logistics_operator: "Prestataire logistique (optionnel)",
                create_logistics_operator: "Créer un prestataire logistique",
                connected: "connecté",
            },
        },
    },
};
</script>
